import React, {useCallback, useEffect, useRef, useState} from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import {cities} from '../../../../../utils/Utils';


function capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
}

const searchOptions = {
    componentRestrictions: { country: "ec" },
}

function Places(props) {

    const {
        setDataCoords, dataCoords, placeholder, keyData, DataStore, setRouteControl, routesControl, address,
        setAddress, setClickControl
    } = props;


    const handleSelect = async value => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        const newValue = capitalize(value);
        setAddress(newValue);
        const res = newValue.split(',').join('');
        const addressArray = res.split(' ');
        let city = '';
        cities.forEach(items => {
            const result = addressArray.filter(city => city === items.id);
            if (result.length > 0) {
                city = result[0];
            } else {
                cities.forEach(items => {
                    const result = addressArray.filter(city => city === items);
                    if (result.length > 0) {
                        city = result[0];
                    }
                });
            }
        });

        if (city === "") {
            city = res
        }

        if (keyData === 'origen') {
            const keyCity = `${keyData}City`;
            setRouteControl({...routesControl, [keyCity]: city});
            setDataCoords({
                ...dataCoords, origenDirection: newValue, [keyData]: [latLng.lat, latLng.lng], [keyCity]: city
            })
            setClickControl(true)
        } else {
            const keyCity = `${keyData}City`;
            setRouteControl({...routesControl, [keyCity]: city});
            setDataCoords({
                ...dataCoords,
                destinationDirection: newValue, [keyData]: [latLng.lat, latLng.lng],
                [keyCity]: city
            });
            setClickControl(false)
        }
    };

    return (
        <div style={{width: '100%', position: 'relative'}}>
            <PlacesAutocomplete
                value={address}
                onChange={(value) => setAddress(value)}
                onSelect={handleSelect}
                searchOptions={searchOptions}
            >

                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (

                    <div className={'origin-place-container'}>
                        <input {...getInputProps({placeholder: placeholder})} className="places-input"/>
                        <div className={'result-autocomplete-container'}>
                            {loading ? <div>...Cargando</div> : null}
                            {suggestions.map((suggestion, i) => {
                                return (
                                    <div {...getSuggestionItemProps(suggestion)} key={i}
                                         className={'result-autocomplete-container'}>
                                        <span className="places-result-span">
                                             {suggestion.description}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </div>
    )
}

export default Places
